
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Task } from '@/types/task';
import { useToast } from '@/hooks/use-toast';

export const useTasks = () => {
  const { toast } = useToast();

  return useQuery({
    queryKey: ['tasks'],
    queryFn: async () => {
      try {
        console.log('Fetching all tasks');

        const { data: tasks, error: tasksError } = await supabase
          .from('tasks')
          .select('*')
          .order('created_at', { ascending: false });

        if (tasksError) {
          console.error('Error fetching tasks:', tasksError);
          throw tasksError;
        }

        console.log('Successfully fetched tasks:', tasks);
        
        return tasks.map((task): Task => ({
          id: task.id,
          title: task.title,
          description: task.description || '',
          isCompleted: task.is_completed,
          createdAt: new Date(task.created_at),
          hebrewTitle: task.hebrew_title,
          hebrewDescription: task.hebrew_description,
          scheduledDay: task.scheduled_day,
          scheduledHour: task.scheduled_hour ? Number(task.scheduled_hour) : undefined,
          scheduledMinute: task.scheduled_minute ? Number(task.scheduled_minute) : undefined,
          coins: task.coins || 0,
        }));
      } catch (error) {
        console.error('Error in useTasks:', error);
        toast({
          title: "Error",
          description: "Failed to fetch tasks. Please try again.",
          variant: "destructive",
        });
        throw error;
      }
    },
    retry: 1,
  });
};
